// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Interest } from './interest';
import { InterestSurvey } from './interest-survey';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InterestSurveyInterest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  information?: string;
  interestId!: number;
  interestSurveyId!: number;
  notes?: string;
  interest!: Interest;
  interestSurvey!: InterestSurvey;
}

